<template>
  <span>
    <svg class="icon-color-1" :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.0996 11.802C21.5996 10.402 20.6996 9.20202 19.1996 9.20202H15.1996C14.5996 9.20202 14.0996 8.70202 14.1996 8.00202L14.6996 4.80202C14.8996 3.90202 14.2996 2.90202 13.3996 2.60202C12.5996 2.30202 11.5996 2.70202 11.1996 3.30202L7.09961 9.40202" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7.09961 18.202L10.1996 20.602C10.5996 21.002 11.4996 21.202 12.0996 21.202H15.8996C17.0996 21.202 18.3996 20.302 18.6996 19.102L19.9396 15.332" :stroke="color" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M2 18.202V8.40195C2 7.00195 2.6 6.50195 4 6.50195H5C6.4 6.50195 7 7.00195 7 8.40195V18.202C7 19.602 6.4 20.102 5 20.102H4C2.6 20.102 2 19.602 2 18.202Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
  }
}
</script>